import React from 'react';
import logo from "../assets/SVG/Logo_new.svg";
import {ButtonComponent} from "@/components";

export type FallbackProps = {
    onRetry: () => void;
};

const FallbackPage: React.FC<FallbackProps> = ({ onRetry }) => {
    return (
        <div className="h-screen dark:bg-gray-800 flex flex-col items-center justify-center">
            <img src={logo} alt="logo"/>
            <h1 className="text-3xl dark:text-white font-bold mb-4">Oops! Something went wrong.</h1>
            <p className="text-gray-600 dark:text-gray-200 mb-8">Please try again later.</p>
            <ButtonComponent
                title={"Retry"}
                actionCallback={onRetry}
                name="button--classic"
            />
        </div>
    );
};

export default FallbackPage;